<template>
  <div class="design_3_block">
    <div class="box">
      <h1 class="h1_first">Наши проекты</h1>
      <div class="row">
        <div class="col-md-4">
          <div class="cart">
            <div class="img_background img_background_1"></div>
            <div class="under_cart">
              <div class="flex">
                <div class="ico_inside_1"></div>
                <div class="ico_inside_1"></div>
                <div class="ico_inside_1"></div>
              </div>
              <p class="text_inside_cart_2">MY PIXEL CLUB</p>
              <p class="text_inside_cart">это проект, который занимается созданием уникальных пиксельных персонажей, которые могут быть использованы в качестве логотипов, анимаций или других видов визуального контента.</p>
              <a class="btn">Проект <div class="icon"></div></a>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="cart">
            <div class="img_background img_background_1"></div>
            <div class="under_cart">
              <div class="flex">
                <div class="ico_inside_1"></div>
                <div class="ico_inside_1"></div>
                <div class="ico_inside_1"></div>
              </div>
              <p class="text_inside_cart_2">MY PIXEL CLUB</p>
              <p class="text_inside_cart">это проект, который занимается созданием уникальных пиксельных персонажей, которые могут быть использованы в качестве логотипов, анимаций или других видов визуального контента.</p>
              <a class="btn">Проект <div class="icon"></div></a>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="cart">
            <div class="img_background img_background_1"></div>
            <div class="under_cart">
              <div class="flex">
                <div class="ico_inside_1"></div>
                <div class="ico_inside_1"></div>
                <div class="ico_inside_1"></div>
              </div>
              <p class="text_inside_cart_2">MY PIXEL CLUB</p>
              <p class="text_inside_cart">это проект, который занимается созданием уникальных пиксельных персонажей, которые могут быть использованы в качестве логотипов, анимаций или других видов визуального контента.</p>
              <a class="btn">Проект <div class="icon"></div></a>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="cart">
            <div class="img_background img_background_1"></div>
            <div class="under_cart">
              <div class="flex">
                <div class="ico_inside_1"></div>
                <div class="ico_inside_1"></div>
                <div class="ico_inside_1"></div>
              </div>
              <p class="text_inside_cart_2">MY PIXEL CLUB</p>
              <p class="text_inside_cart">это проект, который занимается созданием уникальных пиксельных персонажей, которые могут быть использованы в качестве логотипов, анимаций или других видов визуального контента.</p>
              <a class="btn">Проект <div class="icon"></div></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

</script>

<style scoped>
.icon {
  background:url("../../assets/img/design/line.svg");
  background-repeat: no-repeat;
  background-size: 100%;
  width: 18px;
  height: 10px;
  content: "";
  margin-left: 10px;
  background-position: center;
  margin-top: 4px;
}
.btn {
  padding: 10px;
  background-color: #fff;
  font-size: 13px;
  display: flex;
  width: 100px;
  border-radius: 10px;
}
.ico_inside_1 {
  width: 30px;
  height:30px;
  background:url("../../assets/img/design/yii.svg") no-repeat #1A1F31;
  background-position: center;
  border-radius: 10px;
  margin-right: 13px;
  background-size: 
}
.flex {
	display:flex;
  width: 100%;
}
.img_background {
  width:100%;
  height:222px;
  border-radius:20px 20px 0 0;
}
.img_background_1 {
  background:url("../../assets/img/design/cart_under_1.svg") no-repeat #EAEAFF;
  background-size: 100%;
  background-position: center;
}
.text_inside_cart_2 {
	font-size:20px;
	color:#fff;
	margin:20px 0 20px 0;
}
.text_inside_cart {
  font-size:15px;
  margin:0 0 20px 0;
  color:#fff;
}
.under_cart {
  width:100%;
  height: auto;
  padding:20px;
  background:#04121E;
  border-radius:0 0 20px 20px;
}
.cart {
  width:auto;
  height:100%;
  margin-top: 15px;
}
.h1_first {
  margin:0 0 40px 0;
  font-size:30px;
  color:#000;
}
.box {
  max-width: 1262px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 15px 0 15px;

  margin-bottom:20px;
}
@media(max-width:767px) {
  .h1_first {
    font-size:25px;
  }
}
</style>